
// @ts-ignore
import { Plugin } from '@nuxt/types'
// @ts-ignore
declare module 'vue/types/vue' {
  interface Vue {
    $gtmadd(event: string, params: object): void
  }
}
// @ts-ignore
declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $gtmadd(event: string, params: object): void
  }
  interface Context {
    $gtmadd(event: string, params: object): void
  }
}
// @ts-ignore
declare module 'vuex/types/index' {
  interface Store<S> {
    $gtmadd(event: string, params: object): void
  }
}

const Plugin: Plugin = (context: any, inject: any) => {
  inject('gtmadd', (event: string, params: object = {}) => {
    if (context.env && context.env.target && context.env.target === 'production') {
      (params as any).event = event;
      context.$gtm.push(params);
    }
  });
}

export default Plugin
